import {Injectable} from '@angular/core';
import {IProdGridService} from 'prod-grid';
import {HttpExtraParams, HttpFilterParam} from 'prod-shared';
import {Observable} from 'rxjs';
import {AbstractProdSelectService, IProdSelectProperties} from 'prod-select';
import {HttpClient} from "@angular/common/http";
import {OrganizationTreeSelect} from "../dip/organization-tree-select";
import {UserGroup} from "../models/usergroup";

@Injectable({providedIn: 'root'})
export class UserGroupService extends AbstractProdSelectService implements IProdGridService {
  override selectDataUrl: string = 'userGroups';
  override selectProperties: IProdSelectProperties = {
    id: 'id',
    name: 'name'
  };

  constructor(public override httpClient: HttpClient, private organizationTreeSelect: OrganizationTreeSelect) {
    super(httpClient);
  }

  getProdGridData(params?: HttpExtraParams): Observable<Object> {
    return this.httpClient.get<{ data: { result: UserGroup[], totalCount: number }, success: boolean }>(`/api/userGroups`, {params});
  }

  prodGridAdd(values: any): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  prodGridPatch(values: any, id: number): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  prodGridRemove(id: number): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  override getSelectFilters(): HttpFilterParam[] {
    return this.getOrganizationFilter();
  }

  getOrganizationFilter(): HttpFilterParam[] {
    let ids = [];
    ids = ids.concat(this.organizationTreeSelect.ids);
    if (this.organizationTreeSelect.company) ids.push(this.organizationTreeSelect.company.id);
    return [new HttpFilterParam({
      property: 'organizationUserGroup.organization',
      operator: 'in',
      value: ids
    })];
  }
}
